// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2FDbm","productName":"Table_productName__HP4hK"};